
$(document).ready(function () {
    //JQuery for site-wide use
    console.log('Studio Park script loaded');



    //Tab System Fix Start
    $('.sfs-tabstrip ul.nav-tabs li a').click(function (e) {
        //$("html, body").animate({ scrollTop: 0 }, "fast");
        $('ul.nav-tabs li.active').removeClass('active')
        $(this).parent('li').addClass('active')
    });
    //Tab System Fix End


    //// Studio Park Events Start
    // events detail carousel
    $('.sp-img-carousel').slick({ nextArrow: 'a.next-arrow', prevArrow: 'a.prev-arrow' });
    $('.carousel-container').css('visibility', 'visible');
    // events list carousel
    $('.carousel-item-content').on('mousedown touchstart', function (e) {
        var slider = $('.events-carousel-container');
        if ($(e.target).closest('.inner-carousel').length) {
            slider.slick("slickSetOption", "accessibility", false);
            slider.slick("slickSetOption", "draggable", false);
            slider.slick("slickSetOption", "swipe", false);
            slider.slick("slickSetOption", "touchMove", false);
        } else {
            slider.slick("slickSetOption", "accessibility", true);
            slider.slick("slickSetOption", "draggable", true);
            slider.slick("slickSetOption", "swipe", true);
            slider.slick("slickSetOption", "touchMove", true);
        }
    });
    $('.events-carousel-container').slick({ nextArrow: 'a.next-arrow', prevArrow: 'a.prev-arrow' });
    $('.carousel-item-content').css('display', 'block');
    $('.inner-carousel').slick({ arrows: false, dots: true });
    $('.carousel-image').css('display', 'block');
    //// Studio Park Events End


    //MOBILE NAV START
    // Bootstrap 4's collapse plugin (data-toggle="collapse" on the hamburger in the
    // StudioParkPrimaryMobileNav / V2 layouts) opens and closes the menu; this code only
    // reacts to it and applies every open/closed class in the same frame.
    //
    // Previously the click handler waited a hard-coded 500ms, then swapped classes and
    // ran a jQuery "slow" scroll-to-top while scroll locking kicked in, so the menu
    // showed up in 3-4 visible steps over ~1-1.5s. The collapse animation itself is
    // switched off in layouts/_topNavigation.scss (it was already being hidden by a
    // height: 0 !important override).
    //
    // Plain JS except the Bootstrap event hook: BS4 only fires its show/hide events
    // through jQuery (no native DOM events), so that one line has to stay on $.
    (function () {
        var mobileBreakPoint = 768;
        var topNav = document.getElementById('TopNavigation');
        var mobileNav = document.querySelector('.top-navigation-layout-container.mobile');
        var menu = mobileNav ? mobileNav.querySelector('.navbar-collapse') : null;
        if (!topNav || !mobileNav || !menu) return;

        var icon = mobileNav.querySelector('.animated-icon');
        var logo = mobileNav.querySelector('.tp-logo-container');
        var topBanner = document.querySelector('.top-banner-container');

        function setMenuState(isOpen) {
            if (isOpen) {
                // Instant jump; the old animated scroll fought the scroll lock below.
                window.scrollTo(0, 0);
            }

            mobileNav.classList.toggle('mobile-nav-closed', !isOpen);
            topNav.classList.toggle('in-mobile-view', isOpen);
            document.documentElement.classList.toggle('lock-scrolling', isOpen);
            document.body.classList.toggle('lock-scrolling', isOpen);
            if (icon) icon.classList.toggle('open', isOpen);
            if (logo) logo.classList.toggle('show-mobile-text', isOpen);

            // hide/show the top banner if it exists on the page
            if (topBanner) {
                topBanner.classList.toggle('d-none', isOpen);
                topNav.classList.toggle('flex-row', isOpen);
            }
        }

        $(menu).on('show.bs.collapse', function (e) {
            if (e.target === menu) setMenuState(true);
        }).on('hide.bs.collapse', function (e) {
            if (e.target === menu) setMenuState(false);
        });

        // Opened on mobile, then widened past the breakpoint (or rotated): close it, which
        // fires hide.bs.collapse and resets everything. Doing nothing otherwise matters on
        // phones, where the address bar showing/hiding fires resize on every scroll.
        function closeIfDesktop() {
            if (topNav.offsetWidth >= mobileBreakPoint && menu.classList.contains('show')) {
                $(menu).collapse('hide');
            }
        }
        window.addEventListener('resize', closeIfDesktop);
        window.addEventListener('orientationchange', closeIfDesktop);

        // Initial state (adds mobile-nav-closed so the closed header starts white).
        setMenuState(menu.classList.contains('show'));
    })();
    //MOBILE NAV END



    //Studio Park Alert Close
    $('.studio-park-alert-close').click(function () {
        $('.studio-park-alert-message').hide();
    });



    //magnificPopup Example
    //$('.video-carousel-item').magnificPopup({
    //    disableOn: 575,
    //    type: 'iframe',
    //    iframe: {
    //        markup: '<div class="mfp-iframe-scaler">' +
    //            '<div class="mfp-close"></div>' +
    //            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
    //            '<div class="mfp-title">Some caption</div>' +
    //            '</div>'
    //    },
    //    callbacks: {
    //        markupParse: function (template, values, item) {
    //            values.title = item.el.attr('title');
    //        }
    //    },
    //    preloader: false,
    //    fixedContentPos: true
    //});


    //SlickJS Examples
    //SlickJS Carousel for Media Carousel
    //$('.media-carousel').slick({
    //    autoplay: true,
    //    arrows: true,
    //    dots: false,
    //    prevArrow: $('.arrow-left'),
    //    nextArrow: $('.arrow-right')
    //});
    //SlickJS Carousel for Featured News Stories
    //$('.slick-responsive-carousel').slick({
    //    dots: true,
    //    infinite: false,
    //    speed: 300,
    //    slidesToShow: 2,
    //    slidesToScroll: 1,
    //    initialSlide: 0,
    //    variableWidth: true,
    //    centerMode: false,
    //    responsive: [
    //        {
    //            breakpoint: 1024,
    //            settings: {
    //                slidesToShow: 1,
    //                slidesToScroll: 1
    //            }
    //        },
    //        {
    //            breakpoint: 600,
    //            settings: {
    //                slidesToShow: 1,
    //                variableWidth: false
    //            }
    //        }
    //        // You can unslick at a given breakpoint now by adding:
    //        // settings: "unslick"
    //        // instead of a settings object
    //    ]
    //});

    $('.slick-responsive-carousel').each(function (i, div) {
        var id = div.id;
        var carousel = $(div);

        carousel.slick({
            dots: true,
            arrows: true,
            infinite: true,
            prevArrow: $('.left-arrow[data-carouselid="' + id + '"]'),
            nextArrow: $('.right-arrow[data-carouselid="' + id + '"]'),
            slidesToShow: 1,
            adaptiveHeight: true,
        });
    });

    $('.slick-responsive-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var id = $(this).closest('.slick-responsive-carousel').attr("id");
        var caption = $('.image-thumbnail-' + id + '[data-slide-num="' + nextSlide + '"]').attr('data-caption');
        $('.caption-' + id).text(caption);
    });
});


//Shrinking Top Nav snippet
//$(document).on("scroll", function () {
//    if
//    ($(document).scrollTop() > 100) {
//        $("#ContentTopNavigation_T7A285BBA015_Col00").addClass("shrink");
//    }
//    else {
//        $("#ContentTopNavigation_T7A285BBA015_Col00").removeClass("shrink");
//    }
//});